module.exports = __webpack_public_path__ + "static/media/pmt_view-payment-adjustment-submissions.31d0bb62.md";


//////////////////
// WEBPACK FOOTER
// ./src/docs/pmt_view-payment-adjustment-submissions.md
// module id = 1106
// module chunks = 0